(() => {
  'use strict';

  const controllerKey = '__vrsProductDecisionGridController';

  if (window[controllerKey]) {
    window[controllerKey].refresh();
    return;
  }

  const comparisonObservers = new WeakMap();
  let refreshFrame = 0;

  function featureHasContent(section) {
    return Boolean(section?.querySelector('.product-features__image'));
  }

  function getFeatureSection() {
    return Array.from(document.querySelectorAll('.cc-product-features'))
      .find(featureHasContent) || null;
  }

  function getComparisonRows(table) {
    return Array.from(table.querySelectorAll('tbody > tr')).filter((row) => (
      row.querySelector('.product-comparison-grid__th--left')
    ));
  }

  function setComparisonExpanded(section, button, expanded) {
    section.classList.toggle('is-vrs-comparison-expanded', expanded);
    button.setAttribute('aria-expanded', String(expanded));

    const label = button.querySelector('[data-vrs-comparison-toggle-label]');
    const icon = button.querySelector('[data-vrs-comparison-toggle-icon]');

    if (label) label.textContent = expanded ? 'Show less' : 'Show full comparison';
    if (icon) icon.textContent = expanded ? '−' : '+';
  }

  function initializeComparison(section) {
    const table = section?.querySelector('.product-comparison-grid');
    if (!table || table.dataset.vrsCompactReady === 'true') return;

    const rows = getComparisonRows(table);
    const rowsToCollapse = rows.slice(2);

    table.dataset.vrsCompactReady = 'true';

    if (!rowsToCollapse.length) return;

    rowsToCollapse.forEach((row) => {
      row.classList.add('vrs-comparison-row--secondary');

      const mobileLabelRow = row.previousElementSibling;
      if (
        mobileLabelRow
        && mobileLabelRow.classList.contains('lg:hidden')
        && mobileLabelRow.querySelector('.product-comparison-grid__th--top')
      ) {
        mobileLabelRow.classList.add('vrs-comparison-label--secondary');
      }
    });

    if (!table.id) {
      table.id = `VrsProductComparison-${Math.random().toString(36).slice(2, 10)}`;
    }

    const comparisonContainer = section.querySelector('product-comparison-grid > .container');
    if (!comparisonContainer) return;

    const controls = document.createElement('div');
    controls.className = 'vrs-comparison-controls';
    controls.dataset.vrsComparisonControls = '';

    const button = document.createElement('button');
    button.type = 'button';
    button.className = 'vrs-comparison-toggle';
    button.setAttribute('aria-expanded', 'false');
    button.setAttribute('aria-controls', table.id);
    button.innerHTML = [
      '<span data-vrs-comparison-toggle-label>Show full comparison</span>',
      '<span class="vrs-comparison-toggle__icon" data-vrs-comparison-toggle-icon aria-hidden="true">+</span>'
    ].join('');

    button.addEventListener('click', () => {
      const expanded = button.getAttribute('aria-expanded') !== 'true';
      setComparisonExpanded(section, button, expanded);
    });

    controls.appendChild(button);
    comparisonContainer.appendChild(controls);
    setComparisonExpanded(section, button, false);
  }

  function observeComparison(section) {
    if (!section || comparisonObservers.has(section)) return;

    const observer = new MutationObserver(() => {
      window.requestAnimationFrame(() => initializeComparison(section));
    });

    observer.observe(section, { childList: true, subtree: true });
    comparisonObservers.set(section, observer);
  }

  function refresh() {
    refreshFrame = 0;

    const featureSection = getFeatureSection();
    const comparisonSection = document.querySelector('.cc-product-comparison-grid');
    if (!featureSection || !comparisonSection) return;

    let wrapper = featureSection.parentElement?.matches('[data-vrs-product-decision-grid]')
      ? featureSection.parentElement
      : null;

    if (!wrapper) {
      wrapper = document.createElement('div');
      wrapper.className = 'vrs-product-decision-grid';
      wrapper.dataset.vrsProductDecisionGrid = '';
      wrapper.setAttribute('aria-label', 'Product features and related model comparison');
      featureSection.parentNode.insertBefore(wrapper, featureSection);
      wrapper.appendChild(featureSection);
    }

    if (comparisonSection.parentNode !== wrapper) {
      wrapper.appendChild(comparisonSection);
    }

    initializeComparison(comparisonSection);
    observeComparison(comparisonSection);
  }

  function scheduleRefresh() {
    if (refreshFrame) window.cancelAnimationFrame(refreshFrame);
    refreshFrame = window.requestAnimationFrame(refresh);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scheduleRefresh, { once: true });
  } else {
    scheduleRefresh();
  }

  document.addEventListener('shopify:section:load', scheduleRefresh);
  document.addEventListener('shopify:section:reorder', scheduleRefresh);
  document.addEventListener('shopify:section:select', scheduleRefresh);

  window[controllerKey] = {
    refresh: scheduleRefresh
  };
})();
